import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { PageContent } from '@/components';
import { DashboardGrid } from '@/features/performance-dashboard/components/DashboardGrid/DashboardGrid';
import { useTaskContext } from '@/features/performance-dashboard/pages/Task/TaskContext';
import { TaskHeader } from '@/features/performance-dashboard/pages/Task/TaskHeader';
import { TaskProvider } from '@/features/performance-dashboard/pages/Task/TaskProvider';
import { requireAccess } from '@/permissions';
import '../../styles.scss';

export const Route = createFileRoute('/tarefa/$idTarefa/visao-geral')({
  staticData: { title: 'Visão geral da tarefa' },
  beforeLoad: requireAccess('view:manager_dashboard'),
  component: TaskOverviewRoute,
});

function TaskGrid(): JSX.Element {
  const { idTask, dashboardResults, isLoading } = useTaskContext();
  return (
    <DashboardGrid
      isTaskScoped
      idTask={idTask}
      dashboardResults={dashboardResults}
      isLoading={isLoading}
    />
  );
}

function TaskOverviewRoute(): JSX.Element {
  const { idTarefa } = Route.useParams();

  const taskId = Number(idTarefa);
  if (!Number.isInteger(taskId) || taskId <= 0) {
    throw new Error('Invalid idTarefa parameter');
  }

  return (
    <TaskProvider idTask={taskId}>
      <TaskHeader />
      <PageContent>
        <TaskGrid />
      </PageContent>
    </TaskProvider>
  );
}
